import { api } from "../api";
import { parseStatistics } from "../../parsers/statistics/parseStatistics";
import { StatisticItem } from "../../model/statistics/StatisticItem";

export const getStatistics = async (patientId: string): Promise<StatisticItem[]> => {
  const response = await api.services.patientChallenge.getPatientChallengesProgress(patientId);
  return parseStatistics(response.data);
};
